@let visualData = visualDataSource[pageType()];

@if (visualData) {
  <main class="page-not-found">
    <div>
      <img
        [src]="visualData.imgSrc"
        alt="queryParam"
      />
      <h4>{{ visualData.heading || visualData.textLines.join('\n') }}</h4>
      @if (visualData.heading) {
        <p class="page-not-found__text">
          {{ visualData.textLines.join('\n') }}
        </p>
      }
      <div class="page-not-found__actions">
        <a
          class="btn btn-primary"
          data-test="button-back-home-page"
          (click)="clearLoadedPermissions()"
          [routerLink]="routerLinkParams()"
        >
          Späť na úvodnú stránku aplikácie
        </a>

        @if (visualData.actionLogout) {
          <button
            class="btn btn-outline-primary btn-logout"
            (click)="logOut()"
          >
            Odhlásiť
          </button>
        }
      </div>
    </div>
  </main>
}
